import React, { Component, Fragment } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Logo from "../../assets/images/chrisalpha.png";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

class NavMenuMobile extends Component {
  constructor() {
    super();

    this.state = {
      SideNavState: "sideNavClose",
      ContentOverState: "ContentOverlayClose",
      showServices: false,
      showAbout: false,
      showProducts: false,
      showDemo: false,

        // Social links
      facebook_link: "https://www.facebook.com/ChrisAlphaTechCompany/",
      youtube_link: "https://www.youtube.com/@ChrisAlphaTechCompany",
      instagram_link: "https://www.instagram.com/chrisalphatechcompany/",
      linkedin_link: "https://www.linkedin.com/in/chrisalpha-tech-company-limited-4179b12b1",
      tiktok_link: "https://www.tiktok.com/@chris.alpha.tech",
      whatsapp_link: "https://wa.me/256784226089"
    };
  }

  /* Toggle Side Menu */

  MenuBarClickHandler = () => {
    this.SideNavOpenClose();
  };

  ContentOverlayClickHandler = () => {
    this.SideNavOpenClose();
  };

  SideNavOpenClose = () => {
    if (this.state.SideNavState === "sideNavOpen") {
      this.setState({
        SideNavState: "sideNavClose",
        ContentOverState: "ContentOverlayClose",
      });
    } else {
      this.setState({
        SideNavState: "sideNavOpen",
        ContentOverState: "ContentOverlayOpen",
      });
    }
  };

  render() {
    return (
      <Fragment>
        <div className="TopSectionDown">

          {/* Top Bar */}

          <Container fluid className="fixed-top shadow-sm p-2 bg-white">
            <Row className="align-items-center">
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="d-flex justify-content-between align-items-center"
              >
                {/* Hamburger */}

                <Button
                  onClick={this.MenuBarClickHandler}
                  className="btn"
                >
                  <i className="fa fa-bars"></i>
                </Button>

                {/* Logo */}

                <Link to="/">
                  <img
                    className="nav-logo"
                    src={Logo}
                    alt="logo"
                  />
                </Link>

              </Col>
            </Row>
          </Container>

          {/* Side Mobile Menu */}

          <div className={this.state.SideNavState}>
            <div className="mobile-menu p-3">

              {/* Home */}

              <Link
                to="/"
                className="mobile-link"
                onClick={this.MenuBarClickHandler}
              >
                Home
              </Link>

              {/* About */}

              <div
                className="position-relative"
                onMouseEnter={() =>
                  this.setState({ showAbout: true })
                }
                onMouseLeave={() =>
                  this.setState({ showAbout: false })
                }
              >
               <Link
                to="/about"
                className="mobile-link"
                onClick={this.MenuBarClickHandler}
              >
                     About-us
              </Link>
           
            
           
               
              
              </div>

              {/* Products */}

              <div
                className="position-relative"
                onMouseEnter={() =>
                  this.setState({ showProducts: true })
                }
                onMouseLeave={() =>
                  this.setState({ showProducts: false })
                }
              >
                <button className="nav-link btn btn-link d-flex align-items-center">
                  Our Products

                  <FaChevronDown
                    className="ms-2"
                    style={{
                      transition: "0.3s",
                      transform: this.state.showProducts
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </button>

                <div
                  className={`services-dropdown ${
                    this.state.showProducts ? "show" : ""
                  }`}
                >
                  <Link to="/parkease" className="service-item">
                    Parkease
                  </Link>
                  <Link to="/pospresso" className="service-item">
                    Pospresso
                  </Link>
                  <Link to="/pospresso_plus" className="service-item">
                    Pospresso-Plus
                  </Link>
                  <Link to="/cat_homis" className="service-item">
                    CAT HOMIS
                  </Link>
                  <Link to="/tradehub" className="service-item">
                    Trade Hub
                  </Link>
                </div>
              </div>

              {/* Services */}

              <div
                className="position-relative"
                onMouseEnter={() =>
                  this.setState({ showServices: true })
                }
                onMouseLeave={() =>
                  this.setState({ showServices: false })
                }
              >
                <button className="nav-link btn btn-link d-flex align-items-center">
                  Service

                  <FaChevronDown
                    className="ms-2"
                    style={{
                      transition: "0.3s",
                      transform: this.state.showServices
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </button>

                <div
                  className={`services-dropdown ${
                    this.state.showServices ? "show" : ""
                  }`}
                >
                  <Link
                    to="/website-development"
                    className="service-item"
                  >
                    Website Development
                  </Link>

                  <Link
                    to="/domainhosting"
                    className="service-item"
                  >
                    Domain Name & Hosting
                  </Link>

                  <Link
                    to="/cctvcameras"
                    className="service-item"
                  >
                    CCTV Cameras
                  </Link>

                  <Link
                    to="/computerrepair"
                    className="service-item"
                  >
                    Computer Repair & Maintenance
                  </Link>

                  <Link
                    to="/networking"
                    className="service-item"
                  >
                    Computer Networking
                  </Link>
                </div>
              </div>

              {/* Live Demo */}

              <div
                className="position-relative"
                onMouseEnter={() =>
                  this.setState({ showDemo: true })
                }
                onMouseLeave={() =>
                  this.setState({ showDemo: false })
                }
              >
                <button className="nav-link btn btn-link d-flex align-items-center">
                  Live Demo

                  <FaChevronDown
                    className="ms-2"
                    style={{
                      transition: "0.3s",
                      transform: this.state.showDemo
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </button>

                <div
                  className={`services-dropdown ${
                    this.state.showDemo ? "show" : ""
                  }`}
                >
                  <Link to="/parking" className="service-item">
                    Parkease
                  </Link>

                  <Link to="/pospressolive" className="service-item">
                    Pospresso
                  </Link>

                  <Link to="/PospressoPlusLive" className="service-item">
                    Pospresso-plus
                  </Link>

        <Link to="/cathomisLive" className="service-item">
                            Cat Homis
                          </Link>

                  <Link to="/tradehublive" className="service-item">
                    Trade hub
                  </Link>
                </div>
              </div>

              {/* Contact */}

              <Link
                to="/contact"
                className="mobile-link"
                onClick={this.MenuBarClickHandler}
              >
                Contact
              </Link>

            </div>
          </div>

          {/* Overlay */}

          <div
            onClick={this.ContentOverlayClickHandler}
            className={this.state.ContentOverState}
          />

        </div>
      </Fragment>
    );
  }
}

export default NavMenuMobile;